'use strict';

module.exports = function(Authentication,departments, $uibModal, $state, teams) {
    var _this = this;
    this.currentUserIsSupervisor = Authentication.isAuthorized("supervisor");

    //we filter the department to the one in the route
    this.department = departments.filter(function(department) {
        return department.id === $state.params.departmentId;
    })[0];

    //we add the newly resolved teams to the object so as not to resolve
    //the whole structure with every update...
    this.department.teams = teams;

    this.createTeam = function() {
        $uibModal.open({
            animation: true,
            controller: ['$uibModalInstance', '$http', '$stateParams', 'Department', function($uibModalInstance, $http, $stateParams, Department) {
                var _this = this;
                this.team = {
                    name: ''
                };

                this.create = function() {
                    if (!_this.team.name) {
                        return;
                    }

                    _this.loading = true;
                    Department.teams.create({
                            id: $stateParams.departmentId
                        }, _this.team)
                        .$promise
                        .then(function(team) {
                            $uibModalInstance.close(team);
                        })
                        .catch(function(error) {
                            console.log(error);
                            _this.loading = false;
                        });
                };

            }],
            templateUrl: 'dashboard-teams/dashboardCreateTeamModal.html',
            controllerAs: 'modal',
            size: 'sm',
            windowClass: 'dialog',
            bindToController: true
        }).result.then(function(team) {
            team.members = [];
            _this.department.teams.push(team);
            $state.go('dashboard.departments.department.teams.team', {
                teamId: team.id
            });
        });
    };
};
